import { atom } from "recoil";
import { IWarrantyCoverage } from "../types";

export const addStateWarrantyCoverage = atom({
  key: "addStateWarrantyCoverage",
  default: false,
});
export const editStateWarrantyCoverage = atom({
  key: "editStateWarrantyCoverage",
  default: false,
});
export const rowEditWarrantyCoverage = atom<IWarrantyCoverage | undefined>({
  key: "rowEditWarrantyCoverage",
  default: undefined,
});

export const selectedRowsStateWarrantyCoverage = atom<IWarrantyCoverage[]>({
  key: "selectedRowsStateWarrantyCoverage",
  default: [],
});

export const warrantyCoverageFilterText = atom({
  key: "warrantyCoverageFilterText",
  default: "",
});

export const warrantyCoverageFetching = atom({
  key: "warrantyCoverageFetching",
  default: true,
});
export const warrantyCoverageReFetching = atom({
  key: "warrantyCoverageReFetching",
  default: false,
});
